<script>
import store from '@state/store'
import { EVENT_ATTENDEE_VALIDATIONS as validations } from '@events/constant'
import { validationMixin } from 'vuelidate'
import RegistrationForm from '@events/components/registration-form.vue'
import { authComputed } from '@state/helpers'

export default {
  name: 'EventCheckin',
  components: { RegistrationForm },
  mixins: [validationMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    eventForm: {},
    attendeeForm: {},
    wysiwyg: true,
    registrationModalVisible: false,
    currentRegData: null,
    currentRegDataUserId: null,
    currentGuestsRegData: null,
    isGuest: null,
  }),
  computed: {
    ...authComputed,
    eventId() {
      return this.event.otherDetails.id
    },
    hasRegistrationForm() {
      return !!(
        this.event.otherDetails.hasRegistrationForm &&
        this.event.otherDetails.registrationFormFields
      )
    },
    joinedUsersEmails() {
      const usersEmails = []
      this.localJoinedUsers().forEach((user) => {
        if (user.email) {
          usersEmails.push(user.email)
        }
      })
      return usersEmails.join(',')
    },
  },
  created() {
    // Set default values on edit event case
    this.setEventForm()
  },
  methods: {
    localJoinedUsers() {
      var users = []
      for (var i = 0; i < this.event.joinedUsers.length; i++) {
        // var currentCheckedIn = this.event.joinedUsers[i].pivot.checked_in
        users.push(this.event.joinedUsers[i])

        for (var j = 0; j < this.event.joinedUsers[i].guests.length; j++) {
          users.push({
            is_guest: true,
            is_parent_checked_in: !!this.event.joinedUsers[i].pivot.checked_in,
            id: this.event.joinedUsers[i].guests[j].id,
            name: this.event.joinedUsers[i].guests[j].name,
            email: this.event.joinedUsers[i].guests[j].email,
            guests: [],
            image_url: this.event.joinedUsers[i].guests[j].image_url,
            pivot: {
              registration_form_data: this.event.joinedUsers[i].guests[j].pivot
                .registration_form_data,
              checked_in: !!this.event.joinedUsers[i].guests[j].pivot
                .checked_in,
            },
          })
        }

        // for (
        //   var k = 1;
        //   k <=
        //   this.event.joinedUsers[i].pivot.guests_count -
        //     this.event.joinedUsers[i].guests.length;
        //   k++
        // ) {
        //   users.push({
        //     is_guest: true,
        //     is_parent_checked_in: !!this.event.joinedUsers[i].pivot.checked_in,
        //     id: this.event.joinedUsers[i].id,
        //     name: this.event.joinedUsers[i].name + ' guest',
        //     image_url: '',
        //     pivot: {
        //       checked_in: currentCheckedIn - k > 0 ? 1 : 0,
        //     },
        //   })
        // }
      }
      return users
    },
    localJoinedWaitlistUsers() {
      var users = []
      for (var i = 0; i < this.event.joinedWaitlistUsers.length; i++) {
        var currentCheckedIn = this.event.joinedWaitlistUsers[i].pivot
          .checked_in
        users.push(this.event.joinedWaitlistUsers[i])

        for (
          var j = 0;
          j < this.event.joinedWaitlistUsers[i].guests.length;
          j++
        ) {
          users.push({
            is_guest: true,
            is_parent_checked_in: !!this.event.joinedWaitlistUsers[i].pivot
              .checked_in,
            id: this.event.joinedWaitlistUsers[i].guests[j].id,
            name: this.event.joinedWaitlistUsers[i].guests[j].name,
            email: this.event.joinedWaitlistUsers[i].guests[j].email,
            guests: [],
            image_url: this.event.joinedWaitlistUsers[i].guests[j].image_url,
            pivot: {
              registration_form_data: this.event.joinedWaitlistUsers[i].guests[
                j
              ].pivot.registration_form_data,
              checked_in: !!this.event.joinedWaitlistUsers[i].guests[j].pivot
                .checked_in,
            },
          })
        }

        for (
          var k = 1;
          k <=
          this.event.joinedWaitlistUsers[i].pivot.guests_count -
            this.event.joinedWaitlistUsers[i].guests.length;
          k++
        ) {
          users.push({
            is_guest: true,
            is_parent_checked_in: !!this.event.joinedWaitlistUsers[i].pivot
              .checked_in,
            id: this.event.joinedWaitlistUsers[i].id,
            name: this.event.joinedWaitlistUsers[i].name + ' guest',
            image_url: '',
            pivot: {
              checked_in: currentCheckedIn - k > 0 ? 1 : 0,
            },
          })
        }
      }
      return users
    },
    toggleWysiwyg() {
      this.wysiwyg = !this.wysiwyg
    },
    setEventForm() {
      if (!this.event) return
      this.eventForm = this.event.otherDetails
      this.wysiwyg = !this.eventForm.notes
    },
    onSaveClick() {
      this.$emit('save', this.eventForm)
    },
    onCancelClick(payload) {
      this.$emit('cancel', payload)
    },
    onCancelEventClick(payload) {
      this.$emit('cancelEvent', payload)
    },
    onDetachEventClick(payload) {
      this.$emit('detachEvent', payload)
    },
    onAddAttendeeClick() {
      const vuelidate = this.$v.attendeeForm
      vuelidate.$touch()
      // if its still pending or an error is returned do not submit
      if (vuelidate.$pending || vuelidate.$error) return
      // to form submit after this

      return store
        .dispatch('events/setJoinedUsers', {
          eventId: this.eventId,
          attendees: JSON.stringify([this.attendeeForm]),
        })
        .then(() => alert('You have succesfully added attendees!'))
        .catch(() => alert('Something went wrong.'))
    },
    onRemoveAttendeeClick(userId) {
      return store
        .dispatch('events/removeJoinedUser', { eventId: this.eventId, userId })
        .then(({ removedUser: { name } }) =>
          alert(`You have succesfully removed "${name}" from the attendees!`)
        )
        .catch(() => alert('Something went wrong.'))
    },
    addUserToAttendees(userId) {
      return store
        .dispatch('events/addUserToAttendees', {
          eventId: this.eventId,
          userId,
        })
        .then()
        .catch(() => alert('Something went wrong.'))
    },
    checkInUser(value, user) {
      var checkedInValue = 1
      if (!value) {
        checkedInValue = -1
      }

      store.dispatch('events/checkIn', {
        eventId: this.event.otherDetails.id,
        userId: user.id,
        checkedInValue: checkedInValue,
        isGuest: user.is_guest ? user.is_guest : 0,
      })
    },
    checkedInCount() {
      var checkedInCount = 0
      for (var i = 0; i < this.event.joinedUsers.length; i++) {
        checkedInCount += this.event.joinedUsers[i].pivot.checked_in
      }
      return checkedInCount
    },
    exportUserRegistrationInfo() {
      store
        .dispatch('events/registrationData', {
          eventId: this.event.otherDetails.id,
        })
        .then((registrationData) => {
          if (!registrationData.csv) {
            return
          }

          var csvString = registrationData.csv
          var nowIsoTime = new Date().toISOString()
          var fileName =
            this.event.otherDetails.name +
            '-' +
            this.event.otherDetails.id +
            '-' +
            nowIsoTime +
            '.csv'
          if (window.navigator.msSaveOrOpenBlob) {
            // IE
            var blob = new Blob([csvString])
            window.navigator.msSaveOrOpenBlob(blob, fileName)
          } else {
            var a = document.createElement('a')
            a.href = 'data:attachment/csv,' + encodeURIComponent(csvString)
            a.target = '_blank'
            a.download = fileName
            document.body.appendChild(a)
            a.click()
            setTimeout(function() {
              a.remove()
            }, 2000)
          }
        })
    },
    openRegModal(userId, regData, guestsRegData, guestOf) {
      this.currentRegData = regData
      this.currentRegDataUserId = userId
      this.isGuest = guestOf
      this.currentGuestsRegData = guestsRegData
      this.registrationModalVisible = true
    },
  },
  validations,
}
</script>

<template>
  <div class="grid grid-cols-6 gap-6 px-29">
    <BaseFormGroup
      :extra-label="checkedInCount() + '/' + event.otherDetails.maxPeople"
      class="col-span-2"
      label="Checked In:"
    >
      <div class="flex mt-3">
        <div
          class="progress border border-gray-dark rounded-2xl overflow-hidden h-7.5 w-full"
        >
          <div
            class="progress-bar rounded-2xl bg-volunteer_red h-7.5 -ml-1px -mt-1px transition-all duration-200 ease-out"
            role="progressbar"
            :aria-valuenow="checkedInCount()"
            aria-valuemin="0"
            :aria-valuemax="event.otherDetails.maxPeople"
            :style="{
              width: `${(checkedInCount() / event.otherDetails.maxPeople) *
                100}%`,
            }"
          ></div>
        </div>
      </div>
    </BaseFormGroup>

    <div class="col-span-2"> </div>
    <div class="col-span-2 flex justify-end flex-col gap-1">
      <button
        class="button primary-button h-10 leading-relax text-sml rounded-small-button px-3.5"
        @click="exportUserRegistrationInfo"
        >Export User Registration Info</button
      >
      <a
        :href="'mailto:' + joinedUsersEmails"
        class="button primary-button h-10 inline-block leading-10 text-center text-sml rounded-small-button px-3.5 w-full"
        >Email All Users</a
      >
    </div>

    <BaseFormGroup class="col-span-6" label="Attendees:">
      <div class="grid items-start grid-cols-5 gap-6">
        <BaseInputText
          id="name"
          v-model="attendeeForm.name"
          :vuelidate="$v.attendeeForm.name"
          class="col-span-2"
          input-class="h-10"
          placeholder="Name"
          required
        />

        <BaseInputText
          id="email"
          v-model="attendeeForm.email"
          :vuelidate="$v.attendeeForm.email"
          class="col-span-2"
          input-class="h-10"
          placeholder="Email"
          required
        >
          <template v-slot:errors>
            <p v-if="!$v.attendeeForm.email.email">
              You have entered an invalid email.
            </p>
          </template>
        </BaseInputText>
        <button
          class="button primary-button h-10 leading-relax text-sml rounded-small-button px-3.5"
          @click="onAddAttendeeClick"
        >
          Add Attendee
        </button>
      </div>

      <hr class="my-4 border-b border-gray-transparent" />

      <ul>
        <li
          v-for="(user, index) in localJoinedUsers()"
          :key="index"
          class="flex items-center justify-between h-10 px-8 mx-1 mb-2 bg-gray-lightest rounded-comments leading-125"
          :class="[user.is_guest ? 'ml-8' : '']"
        >
          <span>
            <BaseInputChoice
              :id="'checkin-' + user.id"
              v-model="user.pivot.checked_in"
              :name="'checkin-' + user.id"
              type="checkbox"
              :false-value="0"
              :true-value="1"
              @update="checkInUser($event, user)"
            >
            </BaseInputChoice>
            <span>{{ user.name }}</span>
          </span>
          <span>
            <template v-if="hasRegistrationForm">
              <button
                v-for="{ pivot, guests } in [user]"
                :key="guests.length"
                class="inline-flex items-center justify-center w-6 h-6 transition-colors duration-200 rounded-full text-gray-darker text-sml hover:text-blue-darker hover:bg-gray-lighter"
                @click="
                  openRegModal(
                    user.id,
                    pivot.registration_form_data,
                    guests,
                    // eslint-disable-next-line vue/comma-dangle
                    user.is_guest
                  )
                "
              >
                <BaseIcon name="settings" :size="16" />
              </button>
            </template>
            <button
              class="inline-flex items-center justify-center align-right  w-6 h-6 transition-colors duration-200 rounded-full text-blue hover:bg-blue-lighter"
              title="Remove user from Opportunity"
              @click="onRemoveAttendeeClick(user.id)"
            >
              <BaseIcon name="close" />
            </button>
          </span>
        </li>
      </ul>
    </BaseFormGroup>

    <BaseFormGroup class="col-span-6" label="Waitlist Attendees:">
      <ul>
        <li
          v-for="(user, index) in localJoinedWaitlistUsers()"
          :key="index"
          class="flex items-center justify-between h-10 px-8 mx-1 mb-2 bg-gray-lightest rounded-comments leading-125"
          :class="[user.is_guest ? 'ml-8' : '']"
        >
          <span>
            <span>{{ user.name }}</span>
          </span>
          <span>
            <template v-if="hasRegistrationForm">
              <button
                v-for="{ pivot, guests } in [user]"
                :key="guests.length"
                class="inline-flex items-center justify-center w-6 h-6 transition-colors duration-200 rounded-full text-gray-darker text-sml hover:text-blue-darker hover:bg-gray-lighter"
                @click="
                  openRegModal(
                    user.id,
                    pivot.registration_form_data,
                    guests,
                    // eslint-disable-next-line vue/comma-dangle
                    user.is_guest
                  )
                "
              >
                <BaseIcon name="settings" :size="16" />
              </button>
            </template>
            <button
              class="inline-flex items-center justify-center align-right  w-6 h-6 transition-colors duration-200 rounded-full text-blue hover:bg-blue-lighter"
              title="Remove user from Waitlist and add to Attendees"
              @click="addUserToAttendees(user.id)"
            >
              <BaseIcon name="arrow-up" />
            </button>
            <button
              class="inline-flex items-center justify-center align-right  w-6 h-6 transition-colors duration-200 rounded-full text-blue hover:bg-blue-lighter"
              title="Remove user from Event"
              @click="onRemoveAttendeeClick(user.id)"
            >
              <BaseIcon name="close" />
            </button>
          </span>
        </li> </ul
    ></BaseFormGroup>

    <BaseFormGroup class="col-span-6" label="Leader Notes:">
      <template v-slot:extra-label>
        <button
          class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
          @click="toggleWysiwyg"
          v-text="wysiwyg ? 'Done' : 'Edit'"
        />
      </template>
      <wysiwyg v-if="wysiwyg" v-model="eventForm.notes" />
      <div v-else v-html="eventForm.notes"></div>
    </BaseFormGroup>

    <div class="col-span-4">
      <button
        class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
        @click="onSaveClick"
      >
        Save
      </button>

      <button
        class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
        @click="onCancelClick"
      >
        Cancel
      </button>
    </div>
    <div class="col-span-2 text-right">
      <button
        class="button bg-red-500 h-7.5 leading-relax text-sml rounded-small-button px-3 text-white"
        @click="onCancelEventClick"
      >
        Cancel Event
      </button>
      <button
        v-if="event.otherDetails.recurringEnabled"
        class="button bg-blue-darker h-7.5 leading-relax text-sml rounded-small-button px-3 text-white ml-3"
        @click="onDetachEventClick"
      >
        Detach Event
      </button>
    </div>
    <RegistrationForm
      v-if="registrationModalVisible"
      :current-user-id="currentRegDataUserId"
      :event="eventForm"
      :form-fields="eventForm.registrationFormFields"
      :current-reg-data="currentRegData"
      :is-guest="isGuest"
      :current-guests-reg-data="currentGuestsRegData"
      @joined="
        registrationModalVisible = false
        joinedModalVisible = true
        isJoining = false
      "
      @close="
        registrationModalVisible = false
        isJoining = false
        currentRegData = null
        isGuest = null
        currentGuestsRegData = null
      "
    />
  </div>
</template>

<style src="vue-wysiwyg/dist/vueWysiwyg.css" />
